<template>
  <div>
    <!--<b-row class="d-flex justify-content-start">
      <b-col cols="3" class="form-group pr-0">
        <form-write-group-label-input v-model="elementSearchedCA" v-if="typeList === 'configuration'"
          :placeholderValue="$t('common.security.' + searchPlaceholder + '_search')">
        </form-write-group-label-input>
        <form-write-group-label-input v-model="elementSearchedCA" v-else-if="typeList === 'ca'"
          :placeholderValue="$t('common.security.' + searchPlaceholder + '_search')">
        </form-write-group-label-input>
        <form-write-group-label-input v-model="elementSearchedCertif" v-else-if="typeList === 'certificate'"
          :placeholderValue="$t('common.security.' + searchPlaceholder + '_search')">
        </form-write-group-label-input>
        <form-write-group-label-input v-model="elementSearchedPrivKeys" v-else-if="typeList === 'privatekey'"
          :placeholderValue="$t('common.security.' + searchPlaceholder + '_search')">
        </form-write-group-label-input>
      </b-col>
        <b-button class="btnFilter"
          @click="emptyFilters(typeList)">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
        <b-button class="btnFilter ml-2"
          @click="applyFilters(typeList)">
          {{ $t('filter.fltr') }}
        </b-button>
    </b-row>-->
    <b-row>
      <b-col cols="12">
        <div>
          <spinner v-if="activateSpinner"></spinner>
          <b-table v-else-if="listItems.length > 0"
            :items="listItems"
            :fields="fields"
            :sort-by.sync="sortBy"
            class="table-striped"
            fixed hover :selectable="listItems.length > 0"
            empty-text="Pas de résultat"
            @row-selected="onRowSelected">
            <template #cell(name)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(type)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(edit)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.value)">
                <i class="fa-regular fa-pencil"></i>
              </span>
            </template>
            <template #cell(delete)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.value)">
                <i class="fa-regular fa-trash"></i>
              </span>
            </template>
          </b-table>
          <!-- ANCIENNE TABLE DRO : 29/06/2023
          <table relative class="table b-table table-hover" :class="listItems.length ? 'b-table-selectable b-table-select-single' : ''">
            <thead role="rowgroup">
                <tr role="row">
                  <th role="columnheader" class="text-center table-condensed-ipad">{{$t('common.security.' + tableTitle) }}</th>
                  <th role="columnheader" v-if="canEdit && !activateSpinner" class="text-center table-condensed-ipad col-1">{{ $t('rights.edit') }}</th>
                  <th role="columnheader" v-if="canDelete && !activateSpinner" class="text-center table-condensed-ipad col-1">{{ $t('rights.delete') }}</th>
                </tr>
            </thead>
            <tbody role="rowgroup">
                <tr role="row" v-if="activateSpinner">
                <td role="cell" class="text-center py-0">
                    <spinner class=""></spinner>
                </td>
                </tr>
                <tr role="row" v-else-if="listItems.length" v-for="(item, index) in listItems" :key="'item-' + index" @click="actionDetails(item.id)">
                <td role="cell" class="text-center">{{item.name}}</td>
                <td role="cell" v-if="canEdit"  class="text-center" @click="actionEdit($event, item.id)"><i class="fa-regular fa-pencil"></i></td>
                <td role="cell" v-if="canDelete"  class="text-center" @click="actionDelete($event, item.id)"><i class="fa-regular fa-trash"></i></td>
                </tr>
                <tr role="row" v-else class="no-hover">
                <td role="cell" colspan="3" class="text-center font-weight-bold">
                    Pas de résultat
                </td>
                </tr>
            </tbody>
          </table>-->
          <label class="font-bold w-100 d-flex justify-content-center mt-3" v-else>{{ $t('common.no_result') }}</label>
          <!--<b-row class="justify-content-end mt-4 no-gutter">
            <b-button v-if="canAdd" variant="primary" @click="actionAdd" class="mx-2">
              <span class="d-inline">{{ $t('common.security.' + ajouterButtonTitle) }}</span>
            </b-button>
            <b-button v-if="typeList !== 'ca' && false" variant="primary" @click="actionAddPkcs" class="mx-2">
              <span class="d-inline">{{ $t('common.security.add_pkcs') }}</span>
            </b-button>
          </b-row>-->
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'SecurityPage',
  components: {
    // 'form-write-group-label-input':formWriteGroupLabelInput,
    'spinner': Spinner
  },
  props: {
    typeList: {
      Type: String,
      default: 'none'
    }
  },
  data () {
    return {
      activateSpinner: false,
      ajouterButtonTitle: '',
      changeType: false,
      elementSearchedCA: '',
      elementSearchedCertif: '',
      elementSearchedConfig: '',
      elementSearchedPrivKeys: '',
      listItems: [],
      right: [],
      searchPlaceholder: '',
      sortBy: 'name'
    }
  },
  computed: {
    canAdd () {
      return true
      // return this.$engine.rights.rightIs(this.typeList + '_ajouter', true)
    },
    canEdit () {
      return true
      // return this.$engine.rights.rightIs(this.typeList + '_editer', true)
    },
    canDelete () {
      return true
      // return this.$engine.rights.rightIs(this.typeList + '_supprimer', true)
    },
    fields () {
      let fields = []

      fields.push({
        key: 'name',
        label: this.$t('common.nme'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'idPod',
        label: 'Pod',
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'type',
        label: 'Type',
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      /* if (this.canDelete) {
        this.fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad col-1', tdClass: 'p-0' })
      } */
      return fields
    }
  },
  created () {
    this.activateSpinner = true
    switch (this.typeList) {
      case 'ca':
        this.getCA()
        break
      case 'certificate':
        this.getCertificates()
        break
      case 'configuration':
        this.getConfigurations()
        break
      case 'privatekey':
        this.getPrivateKeys()
        break
      default:
        return ''
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, { url: '/security/' + this.typeList + '/add/-1'})
    },
    actionAddPkcs () {
      loadPage(this, { url: '/security/pkcs/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.security.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: id
              }
              if(that.typeList === 'ca'){
                that.$engine.security.ca.delete(params)
                .then(() => {
                  that.$f7.modal({
                    title: that.$t('common.security.ca_deleted'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                  loadPage(that, {url: '/security/0'})
                })
                .catch(e => {
                  errorMessageAlert(e, that, that.$i18n)
                  that.okMessageBox(that.$t('common.security.cert_delete_error'))
                })
              }
              if(that.typeList === 'certificate'){
                that.$engine.security.certificates.delete(params)
                .then(() => {
                  that.$f7.modal({
                    title: that.$t('common.security.cert_deleted'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                  loadPage(that, {url: '/security/1'})
                })
                .catch(e => {
                  errorMessageAlert(e, that, that.$i18n)
                  that.okMessageBox(that.$t('common.security.cert_delete_error'))
                })
              }
              if(that.typeList === 'privatekey'){
                that.$engine.security.private_keys.delete(params)
                .then(() => {
                  that.$f7.modal({
                    title: that.$t('common.security.priv_key_deleted'),
                    buttons: [
                      {
                        text: 'OK',
                        onClick: function () {
                          return
                        }
                      }
                    ]
                  })
                  loadPage(that, {url: '/security/2'})
                })
                .catch(e => {
                  errorMessageAlert(e, that, that.$i18n)
                  that.okMessageBox(that.$t('common.security.priv_key_delete_error'))
                })
              } else {
                return
              }
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    actionDetails (id) {
      if (this.typeList === 'configuration') {
        const idPod = id.split(';')[1]
        const type = id.split(';')[2]
        id = id.split(';')[0]
        loadPage(this, { url: '/security/' + this.typeList + '/view/' + id + '/' + idPod + '/' + type })
      } else {
        loadPage(this, { url: '/security/' + this.typeList + '/view/' + id })
      }
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      if (this.typeList === 'configuration') {
        const idPod = id.split(';')[1]
        const type = id.split(';')[2]
        id = id.split(';')[0]
        loadPage(this, { url: '/security/' + this.typeList + '/edit/' + id + '/' + idPod + '/' + type })
      } else {
        loadPage(this, { url: '/security/' + this.typeList + '/edit/' + id })
      }
    },
    applyFilters (typeList) {
      this.activateSpinner = true
      switch (typeList) {
        case 'ca':
          this.getCA()
          break
        case 'certificate':
          this.getCertificates()
          break
        case 'configuration':
          this.getConfigurations()
          break
        case 'privatekey':
          this.getPrivateKeys()
          break
        default:
          return ''
      }
    },
    emptyFilters (typeList) {
      this.activateSpinner = true
      switch (typeList) {
        case 'ca':
          this.elementSearchedCA = ''
          this.getCA()
          break
        case 'certificate':
         this.elementSearchedCertif = ''
          this.getCertificates()
          break
        case 'configuration':
          this.elementSearchedConfig = ''
          this.getConfigurations()
          break
        case 'privatekey':
          this.elementSearchedPrivKeys = ''
          this.getPrivateKeys()
          break
        default:
          return ''
      }
    },
    getCA () {
      let that = this
      let params = {
        //filtre input
        name : this.elementSearchedCA
      }
      this.$engine.security.ca.fetch(params)
      .then(resp => {
        let CAList = {}

        CAList = resp.data.ca
        for (let i = 0; i < CAList.length; i++) {
          CAList[i].delete = CAList[i].id
          CAList[i].edit = CAList[i].id
        }
        that.updateCA(CAList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
    },
    getCertificates () {
      let that = this
      let params = {
        name : this.elementSearchedCertif
      }
      this.$engine.security.certificates.fetch(params)
      .then(resp => {
        let certificatesList = {}

        certificatesList = resp.data.certificates
        for (let i = 0; i < certificatesList.length; i++) {
          certificatesList[i].delete = certificatesList[i].id
          certificatesList[i].edit = certificatesList[i].id
        }
        that.updateCertificates(certificatesList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
    },
    getConfigurations () {
      let that = this
      let params = {
        name : this.elementSearchedConfig
      }
      this.$engine.security.configssl.fetch(params)
      .then(resp => {
        let configsList = {}

        configsList = resp.data.configs
        /* certificatesList = [{
          name: 'conf 1',
          type: 'SSL'
        },{
          name: 'conf 2',
          type: 'CMS'
        }] */
        for (let i = 0; i < configsList.length; i++) {
          configsList[i].type = 'SSL'
          configsList[i].id = configsList[i].idConfigSSL + ';' + configsList[i].idPod + ';' + configsList[i].type
          configsList[i].delete = configsList[i].idConfigSSL + ';' + configsList[i].idPod + ';' + configsList[i].type
          configsList[i].edit = configsList[i].idConfigSSL + ';' + configsList[i].idPod + ';' + configsList[i].type
        }
        that.$engine.security.configsmime.fetch(params)
        .then(resp => {
          let configsList2 = {}

          configsList2 = resp.data.configs
          for (let i = 0; i < configsList2.length; i++) {
            configsList2[i].type = 'CMS'
            configsList2[i].id = configsList2[i].idConfigSMIME + ';' + configsList2[i].idPod + ';' + configsList2[i].type
            configsList2[i].delete = configsList2[i].idConfigSMIME + ';' + configsList2[i].idPod + ';' + configsList2[i].type
            configsList2[i].edit = configsList2[i].idConfigSMIME + ';' + configsList2[i].idPod + ';' + configsList2[i].type
            configsList.push(configsList2[i])
          }
          that.updateConfigurations(configsList)

          this.$f7.pullToRefreshDone()
          that.activateSpinner = false
        })
      })
    },
    getPrivateKeys () {
      let that = this
      let params = {
        name : this.elementSearchedPrivKeys
      }
      this.$engine.security.private_keys.fetch(params)
      .then(resp => {
        let privateKeysList = {}

        privateKeysList = resp.data.privateKeys
        for (let i = 0; i < privateKeysList.length; i++) {
          privateKeysList[i].delete = privateKeysList[i].id
          privateKeysList[i].edit = privateKeysList[i].id
        }
        that.updatePrivateKeys(privateKeysList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
    },
    onRowSelected (items) {
      this.actionDetails(items[0].id)
    },
    updateCA (CAList) {
      if (this.typeList === 'ca') {
        this.listItems = CAList
      }
    },
    updateCertificates (certificatesList) {
      if (this.typeList === 'certificate') {
        this.listItems = certificatesList
      }
    },
    updateConfigurations (configurationsList) {
      if (this.typeList === 'configuration') {
        this.listItems = configurationsList
      }
    },
    updatePrivateKeys (privateKeysList) {
      if (this.typeList === 'privatekey') {
        this.listItems = privateKeysList
      }
    }
  }
}

</script>
